import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { DomSanitizer } from "@angular/platform-browser";
import { ICellRendererParams } from "ag-grid-community";
import { LadderAggregate } from "../../shared/cubiq-services/model/orders/LadderAggregate";

@Component({
  selector: "ladder-pair-renderer",
  templateUrl: "./html/ladder-pair-renderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LadderPairRenderer implements ICellRendererAngularComp {
  private params: ICellRendererParams;

  value: string;
  tooltip: string;

  isLadderRate: boolean = false;
  isAggregate: boolean = false;
  isAggregated: boolean = false;
  aggregateExpanded: boolean = false;
  hasValue: boolean = false;
  doRefresh: boolean;
  aggregateVisibleCount: number;

  private previous: {
    aggregateExpanded: boolean;
    aggregateVisibleCount: number;
    isAggregated: boolean;
    value: string;
  };

  constructor(
    public sanitizer: DomSanitizer,
    public cd: ChangeDetectorRef,
  ) {
    this.previous = {
      aggregateExpanded: this.aggregateExpanded,
      aggregateVisibleCount: this.aggregateVisibleCount,
      isAggregated: this.isAggregated,
      value: this.value,
    };
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.init(params);
    this.cd.markForCheck();
  }

  private init(params: ICellRendererParams): boolean {
    this.previous.aggregateExpanded = this.aggregateExpanded;
    this.previous.aggregateVisibleCount = this.aggregateVisibleCount;
    this.previous.isAggregated = this.isAggregated;
    this.previous.value = this.value;

    if (params.data.isLadderRate) {
      this.isLadderRate = true;
      this.tooltip = params.data.isInvert
        ? params.data.baseCode + "/" + params.data.nonBaseCode
        : params.data.nonBaseCode + "/" + params.data.baseCode;
      this.value = params.data.isInvert
        ? params.data.nonBaseCode + "/" + params.data.baseCode + " ¹/ₙ"
        : params.data.baseCode + "/" + params.data.nonBaseCode;
    } else if (LadderAggregate.is(params.data) && params.context.supportsAggregation()) {
      this.isAggregate = true;
      this.aggregateExpanded = params.data.aggregateExpanded;
      this.value = params.value;
      this.aggregateVisibleCount = params.data.aggregateVisibleCount;
    } else if (
      params.data.isLadderAggregate === false &&
      params.context.isAggregateExpanded(params.data.aggregateId) &&
      params.context.supportsAggregation()
    ) {
      this.isAggregated = true;
      this.aggregateExpanded = true;
      this.hasValue = true;
      this.value = params.getValue();
    } else {
      this.aggregateExpanded = false;
      this.hasValue = true;
      this.value = params.getValue();
    }

    return (
      this.value !== this.previous.value ||
      this.aggregateExpanded !== this.previous.aggregateExpanded ||
      this.aggregateVisibleCount !== this.previous.aggregateVisibleCount ||
      this.isAggregated !== this.previous.isAggregated
    );
  }

  refresh(row): boolean {
    this.params.data = row.data;
    let doRefresh = this.init(this.params) || this.doRefresh;

    if (doRefresh) {
      this.cd.markForCheck();
      this.doRefresh = false;
    }

    return true;
  }

  doClickAggregate($event: PointerEvent) {
    this.aggregateExpanded = !this.aggregateExpanded;
    this.doRefresh = true;
    this.params.context.clickAggregate($event, this.params);
  }
}
